module.exports = __webpack_public_path__ + "aprile-3.jpg?29975014ad08133c356f676078b30655";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aprile-3.jpg
// module id = 149
// module chunks = 0